import { BarLoader } from "react-spinners";

function LoadingSpinner() {
    return <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

        <div style={{ height: '1rem' }}><BarLoader color="#000" /> </div>
    </div>
}

export default LoadingSpinner;